module.exports = __webpack_public_path__ + "static/media/kick.987fa9f0.wav";